import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox } from '../../../../../shared';
import ValidFromAndToSection from './ValidFromAndToSection';

const TravelReportSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control } = useFormContext();

  return (
    <>
      <ValidFromAndToSection />
      <ControlledCheckbox
        control={control}
        name="ben_flag"
        label={t('inclBenefit')}
      />
    </>
  );
};

export default TravelReportSection;
